import { FC } from 'react'

import styled from 'styled-components'

import { PlaylistCover } from './PlaylistCover'

interface PlaylistInfoProps {
  playlistName: string
  followers: number
  coverUrl?: string
  playlistUrl?: string
}

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: ${({ theme }) => theme.color.white};
  flex: 1;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`

const PlaylistName = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0;
`

const FollowersInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.darkGrey};
`

const FollowersCount = styled.span`
  white-space: nowrap;
`

const FollowersText = styled.span`
  flex: 1;
  min-width: 0;
`

export const PlaylistInfo: FC<PlaylistInfoProps> = ({
  playlistName,
  followers,
  coverUrl,
  playlistUrl,
}) => (
  <InfoContainer>
    <PlaylistCover coverUrl={coverUrl} playlistUrl={playlistUrl} />
    <TextContainer>
      <PlaylistName>{playlistName}</PlaylistName>
      <FollowersInfo>
        <FollowersCount>{followers}</FollowersCount>
        <FollowersText>followers</FollowersText>
      </FollowersInfo>
    </TextContainer>
  </InfoContainer>
)
